// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"775":"gsap","9508":"ScrollTrigger"}[chunkId] || chunkId) + "." + {"775":"52b70335121799b93be2","2206":"3bd261b1a7ee1a32ff20","3929":"9ef0359c660ec27b059e","7379":"f448c1bc5e8a6bbd64c5","7391":"8aa5e6d9a3342f758b6a","8264":"20dfb0320d123a27863e","9508":"d1b640a830ee9c2b02fc","9710":"4baf7fab752bf3bc5b2c"}[chunkId] + ".js";
};